import { createFileRoute } from "@tanstack/react-router";

import ProfilePage from "@/features/profile";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/user/profile")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Profile");

  return <ProfilePage />;
}
